import { JSX, use, useMemo, Suspense } from 'react'

import type { TimelineRootProps } from '@chakra-ui/react'
import { For, HStack, Text, Timeline, Checkmark } from '@chakra-ui/react'

import { RxArchive, RxIdCard, RxFileText } from 'react-icons/rx'


import { HttpBody } from '@/lib/request'

import * as archive_storage from '@/storage/archive.js'
import * as contract_storage from '@/storage/contract.js'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loading from '@/components/ui/loading.tsx'




export type Tcomplete = {
	label: string
	value: boolean

}

export type TcompleteGroup = {
	deposit : Tcomplete[]
	contract: Tcomplete[]

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Checked (props: Tcomplete):	JSX.Element
{
	return (
		<HStack
			px="2"
			py="1"
			rounded="xs"
			justifyContent="space-between"
			_hover={{ bg: 'bg.info' }}

		>
			<Text
				as="span"
				fontSize="sm"
				children={props.label}

			/>

			<Checkmark size="sm" colorPalette="green" checked={props.value} />

		</HStack>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Item
(
	props: {
		title  : string
		icon   : JSX.Element
		options: Tcomplete[]

	},

)
:	JSX.Element
{
	let length = props.options.length
	let finished = props.options.reduce( (a, v) => a + Number(v.value), 0)

	return (
		<Timeline.Item>
			<Timeline.Connector>
				<Timeline.Separator />

				<Timeline.Indicator bg="blue.border">{props.icon}</Timeline.Indicator>

			</Timeline.Connector>

			<Timeline.Content pb="8">
				<Timeline.Title fontSize="lg">{props.title}</Timeline.Title>
				<Timeline.Description>{`共 ${length} 项，已完成 ${finished} 项`}</Timeline.Description>

				<For each={props.options}>
					{ (v, i) => <Checked key={i} label={`${i + 1}. ${v.label}`} value={v.value} />}

				</For>

			</Timeline.Content>

		</Timeline.Item>

	)


}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: TimelineRootProps
		& {
			name    : string
			identity: string

			doc: Promise<null | HttpBody<contract_storage.TRawDocumentType> >

		},

)
:	JSX.Element
{
	let doc = use(props.doc)

	return (
		<Timeline.Root {...props}>
			<Item
				title="员工信息"
				icon={<RxArchive />}
				options={
					[
						{ label: '姓名', value: Boolean(props.name) },
						{ label: '身份证号', value: Boolean(props.identity) },

					]

				}
			/>

			<Item
				title="签约信息"
				icon={<RxIdCard />}
				options={
					[
						{ label: '合同主体', value: Boolean(doc?.sign) },
						{ label: '结算公司', value: Boolean(doc?.settle) },

					]

				}

			/>

			<Item
				title="合同信息"
				icon={<RxFileText />}
				options={
					[
						{ label: '职位', value: Boolean(doc?.office) },
						{ label: '薪水', value: Boolean(doc?.salary) },
						{ label: '险种', value: Boolean(doc?.insurance) },
						{ label: '协议起始日期', value: Boolean(doc?.begin) },
						{ label: '协议结束日期', value: Boolean(doc?.finish) },
						{ label: '银行卡号', value: Boolean(doc?.serial) },
						{ label: '银行名称', value: Boolean(doc?.bank) },
						{ label: '开户网点', value: Boolean(doc?.outlet) },
						{ label: '员工签名', value: Boolean(doc?.signature) },

					]

				}

			/>

		</Timeline.Root>

	)


}

export default function
(
	props: TimelineRootProps
		& {
			doc: HttpBody<archive_storage.TRawDocumentType>

		},

)
:	JSX.Element
{
	let { _id, name, identity } = props.doc

	let doc = useMemo(
		() => archive_storage.retrieve_contract(_id)
			.catch(
				() => null,

			),

		[_id],

	)

	return (
		<Suspense fallback={<Loading.Default h="48vh" />}>
			<Root {...props} name={name} identity={identity} doc={doc} />

		</Suspense>

	)


}

